import React, { useState, useEffect, useCallback } from "react";
import {
    GoogleMap,
    Circle,
    InfoWindow,
    useJsApiLoader
} from "@react-google-maps/api";
import "./EmployeeMap.css";
import AddEmployee from "./AddEmployee";
import fetchBase from "../utils/fetchBase";
import { useNavigate } from "react-router-dom";
import OuraNav from "../components/OuraNav";

const containerStyle = {
    width: "100%",
    height: "700px",
    borderRadius: "1rem",
    boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)"
};

const center = {
    lat: 33.2857,
    lng: -96.5725
};
const libraries = ["places"];

const EmployeeMap = () => {
    const { isLoaded } = useJsApiLoader({
        id: "google-maps-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries
    });

    const [selected, setSelected] = useState(null);
    const [employees, setEmployees] = useState([]);

    const handleCircleClick = useCallback((employee) => {
        setSelected(employee);
    }, []);

    //I understand that EmployeeMap already gets  auth header and admin id from local storage.
    // If the requestMapping in the TimeLogController is /time-log,
    // then that's what I should use when building the fetch URL right?

    useEffect(() => {
        const fetchLiveEmployees = async () => {

            const authHeader = localStorage.getItem("authHeader");

            if (!authHeader) return;

            try {
                const response = await fetch(`${fetchBase}/time-log/active-or-recent`, {
                    headers: {
                        "Authorization": authHeader
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setEmployees(data); // expects: [{ id, name, position, lat, lng }]
                } else {
                    console.error("Failed to fetch employee locations");
                }
            } catch (err) {
                console.error("Error fetching employee locations:", err);
            }
        };

        if (isLoaded) {
            fetchLiveEmployees();
        }
    }, [isLoaded]);

    return (
            <>
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Activity", href: "/activity" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Employees", href: "/employees" },
                    { label: "Calendar", href: "/Scheduler"}
                ]}
            />
            <div
                className="employee-map-container"
            style={{
                backgroundImage: `url('/images/background1.jpg')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}
        >
            <h1 className="map-title">Live Work Zones & Employee Locations</h1>

            <div className="map-split-container">
                <div className="left-panel">
                    <AddEmployee />
                </div>

                <div className="right-panel">
                    {isLoaded && (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={14}
                        >
                            {employees.map((emp) => (
                                <Circle
                                    key={emp.id}
                                    center={{ lat: emp.lat, lng: emp.lng }}
                                    radius={200}
                                    options={{
                                        fillColor: "#a770f8",
                                        fillOpacity: 0.6,
                                        strokeWeight: 0,
                                        clickable: true
                                    }}
                                    onClick={() => handleCircleClick(emp)}
                                />
                            ))}

                            {selected && (
                                <InfoWindow
                                    position={{ lat: selected.lat, lng: selected.lng }}
                                    onCloseClick={() => setSelected(null)}
                                >
                                    <div>
                                        <h4>{selected.name}</h4>
                                        <p>{selected.position}</p>
                                        <p>ID: {selected.id}</p>
                                    </div>
                                </InfoWindow>
                            )}
                        </GoogleMap>
                    )}
                </div>
            </div>
       </div>
       </>
   );
};

export default EmployeeMap;